import { trackCheckoutStep } from "src/tracking/events"
import { createPersistentStore } from "src/utilities/localStorage/create"
import { smoothScrollIntoView } from "src/utilities/scroll"

export enum CheckoutStep {
  ShippingInfo = 1,
  PaymentInfo = 2,
  ExpressCheckoutCompletion = 3,
}

type CheckoutState = {
  step: CheckoutStep
}

const defaultState: CheckoutState = {
  step: CheckoutStep.ShippingInfo,
}

const checkoutStore = createPersistentStore(() => defaultState, { name: "checkout-step" })

export function useCheckoutStep() {
  return checkoutStore((state) => state.step)
}

export function setCheckoutStep(newStep: CheckoutStep) {
  const oldStep = checkoutStore.getState().step

  if (newStep !== oldStep) {
    checkoutStore.setState({ step: newStep })
    smoothScrollIntoView(document.body, { behavior: "smooth", block: "start" })
    trackCheckoutStep(newStep)
  }
}
